import { getSecondsToHoursMinAndSecs } from "@ch/helpers/utils/dates";
import type { FC } from "react";
import { Countdown } from "../Countdown";
import CountdownTimer from "../Countdown/CountdownTimer";

interface InactivityNotificationProps {
  handleLogout: () => void;
}

const InactivityNotification: FC<InactivityNotificationProps> = ({
  handleLogout,
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center gap-4 sm:gap-6">
        <div>
          <Countdown callbackOnComplete={handleLogout} duration={30}>
            {({ currentCountdown }) => {
              const { minWithZeroPrefix, secWithZeroPrefix } =
                getSecondsToHoursMinAndSecs(currentCountdown);

              return (
                <CountdownTimer
                  min={minWithZeroPrefix}
                  sec={secWithZeroPrefix}
                />
              );
            }}
          </Countdown>
        </div>
        <div>
          <h3>Hey, are you still there?</h3>
        </div>
        <div>
          <p className="text-center">
            You have been inactive for a while; you will be logged out shortly
            once the countdown ends.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InactivityNotification;
